let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2aPhr")).then(() => parcelRequire('8dhLy'));